import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import usePortal from './usePortal';
var portalPropTypes = {
  /** If true, the content is rendered in the specified target container. If false, the content is rendered in its current place in the DOM */
  hasPortal: PropTypes.bool,
  /** Content to be rendered in the Portal */
  children: PropTypes.node,
  /** Specifies a refernce to a DOM element */
  container: PropTypes.shape({
    current: PropTypes.shape({
      type: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      props: PropTypes.object
    })
  }),
  /** Classes to be added to Portal container */
  containerClass: PropTypes.string
};
var portalDefaultProps = {
  hasPortal: true,
  container: null,
  children: null,
  containerClass: ''
};

/**
 * @ignore @description
 * ## Portal Component
 * The Portal component leverages the ReactDOM createPortal API to render children into a DOM node that exists outside the DOM hierarchy of the parent component.
 *
 * @ignore @see Mesh: [Portal Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/scaffolding-portal--default)
 *
 * @ignore @example
 * ```jsx
 * import { Portal } from 'mesh-component-library';
 *
 * <Portal {...props} >
 *  {children}
 * </Portal>
 * ```
 */
var Portal = function Portal(props) {
  var containerClass = props.containerClass,
    children = props.children,
    container = props.container,
    hasPortal = props.hasPortal;
  if (hasPortal) {
    var target = usePortal(containerClass, container);
    return /*#__PURE__*/createPortal(children, target);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
Portal.propTypes = portalPropTypes;
Portal.defaultProps = portalDefaultProps;
export default Portal;